export const getDataFromDate = (
  date: string | undefined,
  valueIndex: number,
  defaultValue: string,
): string => {
  return date ? date.split('-')[valueIndex] : defaultValue;
};
